<!-- Zweck: Stellt die HTML-Struktur für app layouts loader component im Frontend bereit. -->
@if (loader.loading$|async) {
  <div class="pageloader">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

@if (loader.loading_percentage$|async) {
  <div class="pageloader">
    <mat-progress-bar mode="determinate" [value]="loader.loading_percentage$|async"></mat-progress-bar>
  </div>
}

